// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"0042b87d","453":"7f7d8a19"}[chunkId] + ".chunk.js";
};